.group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  border: 0;
}

/* The legend is the step's question, so it is set as the page heading. */
.legend {
  margin-bottom: 8px;
  padding: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.15;
}

.intro {
  margin-bottom: 8px;
  color: var(--ink-2);
}

.option {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 0 16px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-weight: 600;
  cursor: pointer;
}

.option:has(:checked) {
  background: var(--accent-soft);
  box-shadow: var(--shadow-button);
}

.radio {
  width: 20px;
  height: 20px;
  margin: 0;
  accent-color: var(--ink);
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
